export const version = 'v2.78.0-8-g318bb588';
